import { BrandPostLog } from "../../types/postLog.types";

export class BrandCampaignPostLogList {
  constructor(
    public readonly items: BrandPostLog[],
    public readonly totalCount: number,
    public readonly _meta: {
      currentPage: number;
      pageCount: number;
      perPage: number;
      totalCount: number;
      totals: {
        publishedAds: number;
        publishedPosts: number;
        scheduledAds: number;
        scheduledPosts: number;
        totalAds: number;
        totalPosts: number;
      };
    },
  ) {}
}
